/* 單獨列傳：陸遜傳（設計見 docs/CAMPAIGN-LUXUN.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「luxun_」，免得和其他列傳撞名。 */
// @ts-nocheck
import luxun1 from '../story/luxun1.ts';
import luxun2 from '../story/luxun2.ts';
import luxun3 from '../story/luxun3.ts';
import luxun4 from '../story/luxun4.ts';
import luxun_shanyue from '../maps/luxun_shanyue.ts';
import luxun_yidu from '../maps/luxun_yidu.ts';
import luxun_shiting from '../maps/luxun_shiting.ts';
import luxun_xiangyang from '../maps/luxun_xiangyang.ts';

export default {
  list: { id: 'luxun', name: '陸遜傳', years: '217–234', parts: [
    { name: '書生篇', chapters: ['luxun-1', 'luxun-2'] },
    { name: '大都督篇', chapters: ['luxun-3', 'luxun-4'] },
  ] },
  chapters: [luxun1, luxun2, luxun3, luxun4],
  maps: { luxun_shanyue, luxun_yidu, luxun_shiting, luxun_xiangyang },
};
